import api from './api';

// Let axios auto-detect Content-Type for FormData (it needs the multipart boundary).
// Explicitly setting 'multipart/form-data' strips the boundary and breaks multer parsing.
const multipart = { headers: { 'Content-Type': undefined } };
const progress = (onProgress) => (e) => onProgress && onProgress(Math.round((e.loaded * 100) / (e.total || 1)));

const listingService = {
  list: () => api.get('/listings').then((r) => r.data),
  create: (data) => api.post('/listings', data).then((r) => r.data),
  get: (id) => api.get(`/listings/${id}`).then((r) => r.data),
  update: (id, data) => api.put(`/listings/${id}`, data).then((r) => r.data),
  saveRequirement: (id, key, data) => api.put(`/listings/${id}/requirements/${key}`, data).then((r) => r.data),
  submit: (id) => api.post(`/listings/${id}/submit`).then((r) => r.data),
  withdraw: (id) => api.post(`/listings/${id}/withdraw`).then((r) => r.data),
  deleteDocument: (id, docId) => api.delete(`/listings/${id}/documents/${docId}`).then((r) => r.data),
  uploadDocument: (id, requirementKey, documentType, file, onProgress) => {
    const fd = new FormData();
    fd.append('listingId', id); fd.append('requirementKey', requirementKey); fd.append('documentType', documentType); fd.append('file', file);
    return api.post('/uploads/listing-documents', fd, { ...multipart, onUploadProgress: progress(onProgress) }).then((r) => r.data);
  },
  uploadPhotos: (id, files, onProgress) => {
    const fd = new FormData();
    fd.append('listingId', id); Array.from(files).forEach((f) => fd.append('files', f));
    return api.post('/uploads/listing-photos', fd, { ...multipart, onUploadProgress: progress(onProgress) }).then((r) => r.data);
  },
  // Eqaya Verification. `{CHECKOUT_SESSION_ID}` is a Stripe placeholder — it is
  // substituted by Stripe when it sends the realtor back, so it must reach the
  // API unencoded, exactly as the property-check checkout does.
  verification: (id) => api.get(`/listings/${id}/verification`).then((r) => r.data),
  startVerificationCheckout: (id) => api.post(`/listings/${id}/verification/checkout`, {
    successUrl: `${window.location.origin}/realtor/listings/${id}/verification/paid?session_id={CHECKOUT_SESSION_ID}`,
    cancelUrl: `${window.location.origin}/realtor/listings/${id}?verification=cancelled`,
  }).then((r) => r.data),
  // The listing fee rides the property-check request table, so it settles through
  // the same confirm endpoint.
  confirmVerificationPayment: (sessionId) => api.post('/property-checks/stripe-checkout/confirm', { sessionId }).then((r) => r.data),
  publish: (id) => api.post(`/listings/${id}/publish`).then((r) => r.data),
  unpublish: (id) => api.post(`/listings/${id}/unpublish`).then((r) => r.data),
  markSold: (id) => api.post(`/listings/${id}/mark-sold`).then((r) => r.data),
};

export default listingService;
